import {connect} from 'react-redux';
import {IReduxStoreState} from '../../@interfaces';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';

const connector = connect((state: IReduxStoreState) => ({locale: state.locale.locale}));

export default connector(Breadcrumbs);
